import React from "react";
import {Chip, Stack, Typography} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Tooltip from "@mui/material/Tooltip";

type ChangeItem = {
  field: string;
  label?: string;
  from?: any;
  to?: any;
  from_text?: string | null;
  to_text?: string | null;
};

type Props = {
  items: ChangeItem[];
  type: any;
};

function getDisplayValue(itemPart: any, itemText?: string | null) {
  // ha van to_text (vagy from_text), mindig azt használjuk
  if (itemText && itemText !== "null" && itemText !== "—") {
    return itemText;
  }

  if (itemPart === null || itemPart === undefined) return "—";

  // ha objektum, akkor a name mezőt keressük
  if (typeof itemPart === "object") {
    if ("name" in itemPart && itemPart.name) {
      return String(itemPart.name);
    }
    if ("id" in itemPart) {
      return "#" + itemPart.id;
    }
    return JSON.stringify(itemPart);
  }

  // ha string / szám / boolean
  if (typeof itemPart === "boolean") return itemPart ? "Yes" : "No";
  return String(itemPart);
}

export const ChangeDiff: React.FC<Props> = ({items, type}) => {
  if (!items || !items.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No changes.
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {items.map((it, idx) => {
        const label = it.label || it.field;
        const fromVal = getDisplayValue(it.from, it.from_text);
        const toVal = getDisplayValue(it.to, it.to_text);

        return (
          <Stack key={idx} spacing={0.5}>
            <Typography variant="body2" sx={{fontWeight: 600}}>
              {label}
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center">
                {type === 'update' && (
                <>
                  <Chip
                    variant="outlined"
                    size="small"
                    label={fromVal}
                  />
                  <ArrowRightAltIcon fontSize="small" />
                </>
              )}
              <Tooltip title={toVal}>
                <Chip
                  variant="filled"
                  size="small"
                  label={toVal}
                />
              </Tooltip>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
